export default "__VITE_ASSET__DIt_U7p$__"